// Mirrors apps/backend/domain/entities/usage_routes.py; the server stores any other route as /other.
export const USAGE_ROUTE_TEMPLATES = [
  "/",
  "/other",
  "/welcome",
  "/welcome/grid",
  "/dashboard",
  "/group-settings",
  "/group-settings/ai-style",
  "/group-settings/permissions",
  "/group-settings/ai-antispam",
  "/group-settings/ai-antispam/statistics",
  "/group-settings/ai-learning",
  "/group-settings/ai-learning/chat-history",
  "/group-settings/ai-learning/chat-history/topics",
  "/group-settings/ai-learning/support",
  "/group-settings/ai-learning/support/trainers",
  "/group-settings/ai-learning/support/topics",
  "/group-settings/ai-learning/sleep-mode",
  "/group-settings/ai-learning/proposals",
  "/group-settings/ai-learning/proposals/:id",
  "/group-settings/event-log",
  "/user-profile",
  "/user-profile/statistics",
  "/user-profile/ai-provider",
  "/user-profile/ai-mode",
  "/user-profile/personal-subscription",
  "/user-profile/finance",
  "/user-profile/finance/subscription",
  "/user-profile/balance/distribute",
  "/user-profile/api-key",
  "/user-profile/card-customization/:mode",
  "/settings",
  "/customization",
  "/moderation",
  "/moderation/level-system",
  "/moderation/level-system/notifications",
  "/moderation/level-system/restrictions",
  "/moderation/level-system/titles",
  "/moderation/level-system/leaderboard",
  "/moderation/service-messages",
  "/moderation/invitation-settings",
  "/moderation/service-messages/commands/edit",
  "/moderation/commands",
  "/moderation/commands/:slug",
  "/moderation/commands/edit",
  "/moderation/reports",
  "/moderation/reports/:reportId",
  "/moderation/blacklist",
  "/moderation/blacklist/create",
  "/moderation/blacklist/:id",
  "/celestia-pro",
  "/celestia-pro/subscription",
  "/celestia-pro/support-mode",
  "/celestia-pro/business-mode",
  "/celestia-pro/business-mode/ai-provider",
  "/celestia-pro/business-mode/onboarding",
  "/celestia-pro/business-mode/start",
  "/celestia-pro/clones",
  "/celestia-pro/clones/create",
  "/celestia-pro/clones/:botId",
  "/celestia-pro/clones/:botId/chats",
  "/support-pro",
  "/business-mode",
  "/captcha-verification",
  "/casino",
  "/chat-grids",
  "/chat-grids/create",
  "/chat-grids/:gridId",
  "/chat-grids/:gridId/chats",
  "/chat-grids/:gridId/chats/add",
  "/chat-grids/:gridId/chats/:chatId",
  "/chat-grids/:gridId/sections/:sectionKey",
  "/chat-grids/:gridId/journal",
  "/chat-grids/:gridId/admins",
  "/chat-grids/:gridId/admins/add",
  "/faq",
  "/faq/basics",
  "/faq/entertainment",
  "/faq/ai",
  "/faq/moderation-functions",
  "/faq/moderation-commands",
  "/faq/rating",
  "/faq/ai-antispam",
  "/faq/chat-cleanup",
  "/faq/reports",
  "/faq/event-log",
  "/faq/ai-training",
  "/faq/ai-learning",
  "/faq/support-mode",
  "/faq/business-mode",
  "/faq/clones",
  "/faq/grid",
  "/faq/plans",
  "/faq/api-key",
  "/dev/xp-prototype"
] as const

export const OTHER_USAGE_ROUTE = "/other"

const knownRoutes: ReadonlySet<string> = new Set(USAGE_ROUTE_TEMPLATES)

export const toUsageRoute = (template: string): string => (knownRoutes.has(template) ? template : OTHER_USAGE_ROUTE)
